import { render, staticRenderFns } from "./customer-add.vue?vue&type=template&id=62b0483c&"
import script from "./customer-add.vue?vue&type=script&lang=js&"
export * from "./customer-add.vue?vue&type=script&lang=js&"
import style0 from "./customer-add.vue?vue&type=style&index=0&id=62b0483c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports